import { Box, IconButton, InputAdornment, TextField } from '@mui/material'
import { MRT_Column } from 'material-react-table'
import { ReactElement, useMemo } from 'react'
import { ClearIcon } from '@mui/x-date-pickers'

interface CustomTextFilterProps<DataType extends Record<string, any>> {
    column: MRT_Column<DataType>
}

const AlertsListCustomFilters = <DataType extends Record<string, any>>({
    column,
}: CustomTextFilterProps<DataType>): ReactElement => {
    const filterValue = column.getFilterValue() ?? ''

    const columnHeaderLabelWidth = useMemo(() => {
        const element = document.getElementById(`column-header-${column.id}`)
        if (element) {
            const labelElement = element.querySelector(
                '.Mui-TableHeadCell-Content-Wrapper',
            )
            const rect = labelElement?.getBoundingClientRect()
            if (rect) {
                if (window.innerWidth - rect?.x <= 300) {
                    return '-230px'
                } else {
                    const leftgap = rect?.width + 20
                    return '-' + leftgap + 'px'
                }
            } else {
                return '-70px'
            }
        } else {
            return '-70px'
        }
    }, [column])

    const filterComponent = (
        <TextField
            size="small"
            sx={{ width: '100%' }}
            placeholder={`Search ${column.columnDef.header}`}
            value={filterValue}
            onChange={(e) => column.setFilterValue(e.target.value)}
            variant="outlined"
            slotProps={{
                input: {
                    endAdornment: filterValue ? (
                        <InputAdornment position="end">
                            <IconButton
                                size="small"
                                onClick={() => column.setFilterValue(undefined)}
                            >
                                <ClearIcon fontSize="small" />
                            </IconButton>
                        </InputAdornment>
                    ) : null,
                },
            }}
        />
    )

    return (
        <Box
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
            onKeyUp={(e) => e.stopPropagation()}
            sx={{
                width: '250px',
                position: 'absolute',
                top: '25px',
                left: columnHeaderLabelWidth,
                background: '#fff',
                // padding: '10px',
                borderRadius: '5px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.50)',
            }}
            className="list-custom-column-filter"
        >
            {filterComponent}
        </Box>
    )
}

export default AlertsListCustomFilters
